import { FormControlLabel, Checkbox, Stack } from "@mui/material";
import React, { useState } from "react";
import DropdownOrgSelection from "./hoa-email-org-selection-dropdown";

const initialValue = (state: any) => state.emailNonAssignable || false;
const initialValueOfOrg = (state: any) => state.nonAssignedEmailOrg || "";

export default function NonAssignableComponent({ state, setState, isPropertyListChange }: any) {
	const [isAssignable, updateNonAssignable] = useState(initialValue(state));

	const toggleNonAssignable = (event: React.ChangeEvent<HTMLInputElement>) => {
		updateNonAssignable(event.target.checked);
		setState({
			...state,
			emailNonAssignable: event.target.checked,
		});
	};

	const [value, setValue] = useState(initialValueOfOrg(state));

	const handleChange = (event: any) => {
		const value = event.target.value;
		setValue(value);
		setState({
			...state,
			nonAssignedEmailOrg: value,
		});
	};

	const isPropertyAlreadyAssigned = state.status === "Assigned" || state.status === "Processing";

	return (
		<Stack flexDirection={"row"} justifyContent={"space-between"}>
			<FormControlLabel
				disabled={isPropertyAlreadyAssigned || isPropertyListChange}
				control={<Checkbox checked={isAssignable} onChange={toggleNonAssignable} />}
				label="Non-Assignable"
			/>
			{isAssignable && <DropdownOrgSelection handleChange={handleChange} value={value} />}
		</Stack>
	);
}
